/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {fetchGstDetails, getProductList, gstValidationCall, panValidationCall, kycVerificationCall, saveBusinessDetails, fetchKycDetailsCall, postSelectedProducts, getStepDetails, MccFromGst, getDigiUrl, selfServeSaveAndNextAPI, getPanAndGstDetails, getDigiDetails, getVideoKycUrl, getVideoKycStatus, getStatesData, getCityData, updateReviewStep,bankAccountVerificationCall, completeVideoKycJourney, sendOtpPdf, verifyOtpPdf, showPdf, showOpportunityStatus, toggleEnv, getCINNumberValidation, createReviewRequest, deleteReviewRequest, confirmChildSelectionApi, fetchUploadDocumentsApi, uploadDocumentApi, generateESignUrlApi, sendEmailCompanyDirectorApi, getEsignStatusApi, publicTokenSelfServeVerificationCall, panValidationKycAgreement, getAgreementEsignUrlApi, getDocumentEsignStatusApi, getAgreementEsignStatusApi, sendEmailKycAgreementApi, rejectionApi, addAndUpdateBeneficiaryApi, resendEmailBeneficiaryApi, getBeneficiaryOwnersApi, getDownloadReportsApi, sendVerificationCodeCkyc, verifyCkycOtp, downloadCkycData, mapCkycData, sidebarStepClickAPI, autosaveStepAPI, updatePciDssConsentApi } from 'api/onboarding';
import ActionConstants from '../constants';

const withHiddenLoader = (payload) => ({
  ...payload,
  hideLoader: payload?.hideLoader ?? true,
});

type LoaderOptions = {
  hideLoader?: boolean;
  loaderMessage?: string;
};

export const fetchStepDetails = () => {
   const payload = {
    serviceMethod: getStepDetails.bind(null, {
      cancelKey: ActionConstants.GET_STEP_DETAILS,
    }),
    actionTypeSuccess: ActionConstants.GET_STEP_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_STEP_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.GET_STEP_DETAILS_REQUEST,
    hideLoader: true,
    cancelKey: ActionConstants.GET_STEP_DETAILS,
  };
  return {type: ActionConstants.GET_STEP_DETAILS, payload: withHiddenLoader(payload)};
};

export const selfServeSaveAndNextAction = (data) => {
  const payload = {
    serviceMethod: selfServeSaveAndNextAPI.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_FAILURE,
    actionTypeRequest: ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_REQUEST,
  };
  return { type: ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT, payload: withHiddenLoader(payload) };
};

export const clearSaveAndNextAction = () => {
  return { type: ActionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_CLEAR };
};

export const sidebarStepClickAction = (data: {target_step: string }) => {
  const payload = {
    serviceMethod: sidebarStepClickAPI.bind(null, data),
    actionTypeSuccess: ActionConstants.SIDEBAR_STEP_CLICK_SUCCESS,
    actionTypeFailure: ActionConstants.SIDEBAR_STEP_CLICK_FAILURE,
    actionTypeRequest: ActionConstants.SIDEBAR_STEP_CLICK_REQUEST,
  };
  return { type: ActionConstants.SIDEBAR_STEP_CLICK, payload: withHiddenLoader(payload) };
};

export const clearSidebarStepClickAction = () => {
  return { type: ActionConstants.SIDEBAR_STEP_CLICK_CLEAR };
};

export const autosaveStepAction = (data) => {
  const payload = {
    serviceMethod: autosaveStepAPI.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_AUTOSAVE_STEP_SUCCESS,
    actionTypeFailure: ActionConstants.POST_AUTOSAVE_STEP_FAILURE,
    actionTypeRequest: ActionConstants.POST_AUTOSAVE_STEP_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.POST_AUTOSAVE_STEP, payload: withHiddenLoader(payload) };
};

export const clearAutosaveStepAction = () => {
  return { type: ActionConstants.POST_AUTOSAVE_STEP_CLEAR };
};

export const fetchMccFromGstAction = () =>{
  const payload = {
    serviceMethod: MccFromGst.bind(null),
    actionTypeSuccess: ActionConstants.GET_MCC_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_MCC_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.GET_MCC_DETAILS_REQUEST,
    genericErrorHandling: false,
  };
  return {type: ActionConstants.GET_MCC_DETAILS, payload: withHiddenLoader(payload)};
};

export const clearMccDetailsAction = () => {
  return { type: ActionConstants.GET_MCC_DETAILS_CLEAR };
};

export const businessDetailsAction = (data) => {
  const payload = {
    serviceMethod: saveBusinessDetails.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SAVE_BUSINESS_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SAVE_BUSINESS_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.POST_SAVE_BUSINESS_DETAILS_REQUEST,
  };
  return { type: ActionConstants.POST_SAVE_BUSINESS_DETAILS, payload: withHiddenLoader(payload) };
};

export const clearBusinessDetailsAction = () => {
    return { type: ActionConstants.POST_SAVE_BUSINESS_DETAILS_CLEAR };
};

export const kycVerificationAction = (data) => {
  const payload = {
    serviceMethod: kycVerificationCall.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_KYC_VERIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_KYC_VERIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_KYC_VERIFICATION_REQUEST,
  };
  return { type: ActionConstants.POST_KYC_VERIFICATION, payload: withHiddenLoader(payload) };
};

export const clearKycVerificationAction = () => {
    return { type: ActionConstants.POST_KYC_VERIFICATION_CLEAR };
};

export const publicTokenSelfServeVerificationAction = (data) => {
  const payload = {
    serviceMethod: publicTokenSelfServeVerificationCall.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_REQUEST,
  };
  return { type: ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION, payload: withHiddenLoader(payload) };
};

export const clearPublicTokenSelfServeVerificationAction = () => {
    return { type: ActionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_CLEAR };
};

export const fetchKycDetailsAction = (data) => {
  const payload = {
    serviceMethod: fetchKycDetailsCall.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_FETCH_KYC_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.POST_FETCH_KYC_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.POST_FETCH_KYC_DETAILS_REQUEST,
  };
  return { type: ActionConstants.POST_FETCH_KYC_DETAILS, payload: withHiddenLoader(payload) };
};

export const clearFetchKycDetailsAction = () => {
    return { type: ActionConstants.POST_FETCH_KYC_DETAILS_CLEAR };
};

export const productListingAction = () => {
  const payload = {
    serviceMethod: getProductList.bind(null),
    actionTypeSuccess: ActionConstants.GET_PRODUCT_LISTING_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PRODUCT_LISTING_FAILURE,
    actionTypeRequest: ActionConstants.GET_PRODUCT_LISTING_REQUEST,
  };
  return { type: ActionConstants.GET_PRODUCT_LISTING, payload: withHiddenLoader(payload) };
};

export const clearProductListingAction = () => {
    return { type: ActionConstants.GET_PRODUCT_LISTING_CLEAR };
};

export const selectedProductListingAction = (data) => {
  const payload = {
    serviceMethod: postSelectedProducts.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SELECTED_PRODUCT_LISTING_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SELECTED_PRODUCT_LISTING_FAILURE,
    actionTypeRequest: ActionConstants.POST_SELECTED_PRODUCT_LISTING_REQUEST,
  };
  return { type: ActionConstants.POST_SELECTED_PRODUCT_LISTING, payload: withHiddenLoader(payload) };
};

export const clearSelectedProductListingAction = () => {
    return { type: ActionConstants.POST_SELECTED_PRODUCT_LISTING_CLEAR };
};


export const getDigiVerificationUrlAction = (data, publicPayload = null) =>{  
  const payload = {
    serviceMethod: getDigiUrl.bind(null,data, publicPayload),
    actionTypeSuccess: ActionConstants.GET_DIGI_VERIFY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_DIGI_VERIFY_FAILURE,
    actionTypeRequest: ActionConstants.GET_DIGI_VERIFY_REQUEST,
  };
  return {type: ActionConstants.GET_DIGI_VERIFY, payload: withHiddenLoader(payload)};
};

export const clearDigiVerificationUrlAction = () => {
    return { type: ActionConstants.GET_DIGI_VERIFY_CLEAR };
};

export const getDetailsFromDigiAction = (data, publicPayload = null) =>{
  const payload = {
    serviceMethod: getDigiDetails.bind(null,data, publicPayload),
    actionTypeSuccess: ActionConstants.GET_DIGI_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_DIGI_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.GET_DIGI_DETAILS_REQUEST,
  };
  return {type: ActionConstants.GET_DIGI_DETAILS, payload: withHiddenLoader(payload)};
};

export const clearDigiDetailsAction = () => {
    return { type: ActionConstants.GET_DIGI_DETAILS_CLEAR };
};

export const getPanAndGstDetailsAction = (data) =>{
  const payload = {
    serviceMethod: getPanAndGstDetails.bind(null,data),
    actionTypeSuccess: ActionConstants.GET_PAN_AND_GST_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PAN_AND_GST_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.GET_PAN_AND_GST_DETAILS_REQUEST,
  };
  return {type: ActionConstants.GET_PAN_AND_GST_DETAILS, payload: withHiddenLoader(payload)};
};

export const clearPanAndGstDetailsAction = () => {
    return { type: ActionConstants.GET_PAN_AND_GST_DETAILS_CLEAR };
};

export const panValidationAction = (data) => {
  const payload = {
    serviceMethod: panValidationCall.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_PAN_VALIDATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_PAN_VALIDATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_PAN_VALIDATION_REQUEST,
  };
  return { type: ActionConstants.POST_PAN_VALIDATION, payload: withHiddenLoader(payload) };
};

export const clearPanValidationAction = () => {
    return { type: ActionConstants.POST_PAN_VALIDATION_CLEAR };
};

export const fetchGstDetailsAction = (data) => {
  const payload = {
    serviceMethod: fetchGstDetails.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_FETCH_GST_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.POST_FETCH_GST_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.POST_FETCH_GST_DETAILS_REQUEST,
  };
  return { type: ActionConstants.POST_FETCH_GST_DETAILS, payload: withHiddenLoader(payload) };
};

export const clearFetchGstDetailsAction = () => {
    return { type: ActionConstants.POST_FETCH_GST_DETAILS_CLEAR };
};

export const gstValidationAction = (data) => {
  const payload = {
    serviceMethod: gstValidationCall.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_GST_VALIDATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_GST_VALIDATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_GST_VALIDATION_REQUEST,
  };
  return { type: ActionConstants.POST_GST_VALIDATION, payload: withHiddenLoader(payload) };
};

export const clearGstValidationAction = () => {
    return { type: ActionConstants.POST_GST_VALIDATION_CLEAR };
};

export const getVideoKycUrlAction= (publicPayload = null)=>{
  const payload = {
    serviceMethod: getVideoKycUrl.bind(null, publicPayload),
    actionTypeSuccess: ActionConstants.GET_VIDEO_KYC_URL_SUCCESS,
    actionTypeFailure: ActionConstants.GET_VIDEO_KYC_URL_FAILURE,
    actionTypeRequest: ActionConstants.GET_VIDEO_KYC_URL_REQUEST,
  };
  return {type: ActionConstants.GET_VIDEO_KYC_URL, payload: withHiddenLoader(payload)};
  };

  export const clearVideoUrlAction = () => {
    return { type: ActionConstants.GET_VIDEO_KYC_URL_CLEAR };
  };


  export const getVideoKycStatusAction= (publicPayload = null, options: LoaderOptions = {})=>{
    
    const payload = {
      serviceMethod: getVideoKycStatus.bind(null, publicPayload),
      actionTypeSuccess: ActionConstants.GET_VIDEO_KYC_STATUS_SUCCESS,
      actionTypeFailure: ActionConstants.GET_VIDEO_KYC_STATUS_FAILURE,
      actionTypeRequest: ActionConstants.GET_VIDEO_KYC_STATUS_REQUEST,
      ...options,
    };
    return {type: ActionConstants.GET_VIDEO_KYC_STATUS, payload: withHiddenLoader(payload)};
  };


  export const completeVideoKycJourneyAction= (publicPayload = null)=>{
    const payload = {
      serviceMethod: completeVideoKycJourney.bind(null, publicPayload),
      actionTypeSuccess: ActionConstants.COMPLETE_VIDEO_KYC_JOURNEY_SUCCESS,
      actionTypeFailure: ActionConstants.COMPLETE_VIDEO_KYC_JOURNEY_FAILURE,
      actionTypeRequest: ActionConstants.COMPLETE_VIDEO_KYC_JOURNEY_REQUEST,
    };
    return {type: ActionConstants.COMPLETE_VIDEO_KYC_JOURNEY, payload: withHiddenLoader(payload)};
  };

  export const getStatesDataAction = (publicPayload = null)=>{
    const payload = {
      serviceMethod: getStatesData.bind(null, publicPayload),
      actionTypeSuccess: ActionConstants.GET_STATES_DATA_SUCCESS,
      actionTypeFailure: ActionConstants.GET_STATES_DATA_FAILURE,
      actionTypeRequest: ActionConstants.GET_STATES_DATA_REQUEST,
    };
    return {type: ActionConstants.GET_STATES_DATA, payload: withHiddenLoader(payload)};
  };


  export const getCityDataAction = (data) => {
    const payload = {
      serviceMethod: getCityData.bind(null,data),
      actionTypeSuccess: ActionConstants.GET_CITY_DATA_SUCCESS,
      actionTypeFailure: ActionConstants.GET_CITY_DATA_FAILURE,
      actionTypeRequest: ActionConstants.GET_CITY_DATA_REQUEST,
    };
    return {type: ActionConstants.GET_CITY_DATA, payload: withHiddenLoader(payload)};
  };

  export const updateReviewStepAction = (data) =>{
    const payload = {
      serviceMethod: updateReviewStep.bind(null,data),
      actionTypeSuccess: ActionConstants.UPDATE_REVIEW_STEP_SUCCESS,
      actionTypeFailure: ActionConstants.UPDATE_REVIEW_STEP_FAILURE,
      actionTypeRequest: ActionConstants.UPDATE_REVIEW_STEP_REQUEST,
    };
    return {type: ActionConstants.UPDATE_REVIEW_STEP, payload: withHiddenLoader(payload)};
  };

  // export const getKycImageAction = (docUtilId) => {
  //   const payload = {
  //     serviceMethod: getKycImage.bind(null, docUtilId),
  //     actionTypeSuccess: ActionConstants.GET_KYC_IMAGE_SUCCESS,
  //     actionTypeFailure: ActionConstants.GET_KYC_IMAGE_FAILURE,
  //     actionTypeRequest: ActionConstants.GET_KYC_IMAGE_REQUEST,
  //   };
  
  //   return { type: ActionConstants.GET_KYC_IMAGE, payload: withHiddenLoader(payload) };
  // };
  
export const bankAccountVerificationAction = (data) => {
  const payload = {
    serviceMethod: bankAccountVerificationCall.bind(null, data), 
    actionTypeSuccess: ActionConstants.POST_BANK_ACCOUNT_VERIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_BANK_ACCOUNT_VERIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_BANK_ACCOUNT_VERIFICATION_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.POST_BANK_ACCOUNT_VERIFICATION, payload: withHiddenLoader(payload) };
};

export const clearBankAccountVerificationAction = () => {
  return { type: ActionConstants.POST_BANK_ACCOUNT_VERIFICATION_CLEAR };
};


export const sendOtpPdfAction = (data) => {
  const payload = {
    serviceMethod: sendOtpPdf.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SEND_OTP_PDF_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SEND_OTP_PDF_FAILURE,
    actionTypeRequest: ActionConstants.POST_SEND_OTP_PDF_REQUEST,
  };
  return { type: ActionConstants.POST_SEND_OTP_PDF, payload: withHiddenLoader(payload) };
};

export const clearSendOtpPdfAction = () => {
  return { type: ActionConstants.POST_SEND_OTP_PDF_CLEAR };
};

export const verifyOtpPdfAction = (data) =>{
  const payload = {
    serviceMethod: verifyOtpPdf.bind(null,data),
    actionTypeSuccess: ActionConstants.POST_VERIFY_OTP_PDF_SUCCESS,
    actionTypeFailure: ActionConstants.POST_VERIFY_OTP_PDF_FAILURE,
    actionTypeRequest: ActionConstants.POST_VERIFY_OTP_PDF_REQUEST,
  };
  return { type: ActionConstants.POST_VERIFY_OTP_PDF, payload: withHiddenLoader(payload) };
};

export const clearVerifyOtpPdfAction = () => {
  return { type: ActionConstants.POST_VERIFY_OTP_PDF_CLEAR };
};

export const showPdfAction = (publicPayload = null) => {
  const payload = {
    serviceMethod: showPdf.bind(null, publicPayload),
    actionTypeSuccess: ActionConstants.SHOW_PDF_SUCCESS,
    actionTypeFailure: ActionConstants.SHOW_PDF_FAILURE,
    actionTypeRequest: ActionConstants.SHOW_PDF_REQUEST,
  };
  return { type: ActionConstants.SHOW_PDF, payload: withHiddenLoader(payload) };
};

export const clearShowPdfAction = () => {
  return { type: ActionConstants.SHOW_PDF_CLEAR };
};

export const showOpportunityStatusAction = (data) => {
  const payload = {
    serviceMethod: showOpportunityStatus.bind(null, data),
    actionTypeSuccess: ActionConstants.SHOW_OPPORTUNITY_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.SHOW_OPPORTUNITY_STATUS_FAILURE,
    actionTypeRequest: ActionConstants.SHOW_OPPORTUNITY_STATUS_REQUEST,
  };
  return { type: ActionConstants.SHOW_OPPORTUNITY_STATUS, payload: withHiddenLoader(payload) };
};


export const toggleSelfServeAction = (data) => {
  const payload = {
    serviceMethod: toggleEnv.bind(null, data),
    actionTypeSuccess: ActionConstants.TOGGLE_ENVIRONMENT_SUCCESS,
    actionTypeFailure: ActionConstants.TOGGLE_ENVIRONMENT_FAILURE,
    actionTypeRequest: ActionConstants.TOGGLE_ENVIRONMENT_REQUEST,
    hideLoader: false,
  };
  return { type: ActionConstants.TOGGLE_ENVIRONMENT, payload: withHiddenLoader(payload) };
};

export const clearToggleSelfServeAction = () => {
  return { type: ActionConstants.TOGGLE_ENVIRONMENT_CLEAR };
};

export const getCINNumberValidationAction = (data) => {
  const payload = {
    serviceMethod: getCINNumberValidation.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_CIN_NUMBER_VALIDATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_CIN_NUMBER_VALIDATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_CIN_NUMBER_VALIDATION_REQUEST,
  };
  return { type: ActionConstants.POST_CIN_NUMBER_VALIDATION, payload: withHiddenLoader(payload) };
};

export const clearCINNumberValidationAction = () => {
    return { type: ActionConstants.POST_CIN_NUMBER_VALIDATION_CLEAR };
};

export const createReviewRequestAction = (data) =>{
  const payload = {
    serviceMethod: createReviewRequest.bind(null,data),
    actionTypeSuccess: ActionConstants.CREATE_REVIEW_REQUEST_SUCCESS,
    actionTypeFailure: ActionConstants.CREATE_REVIEW_REQUEST_FAILURE,
    actionTypeRequest: ActionConstants.CREATE_REVIEW_REQUEST_REQUEST,
  };
  return { type: ActionConstants.CREATE_REVIEW_REQUEST, payload: withHiddenLoader(payload) };
};

export const clearCreateReviewRequestAction = () => {
  return { type: ActionConstants.CREATE_REVIEW_REQUEST_CLEAR };
};

export const deleteReviewRequestAction = (data) =>{
  const payload = {
    serviceMethod: deleteReviewRequest.bind(null,data),
    actionTypeSuccess: ActionConstants.DELETE_REVIEW_REQUEST_SUCCESS,
    actionTypeFailure: ActionConstants.DELETE_REVIEW_REQUEST_FAILURE,
    actionTypeRequest: ActionConstants.DELETE_REVIEW_REQUEST_REQUEST,
  };
  return { type: ActionConstants.DELETE_REVIEW_REQUEST, payload: withHiddenLoader(payload) };
};

export const clearDeleteReviewRequestAction = () => {
  return { type: ActionConstants.DELETE_REVIEW_REQUEST_CLEAR };
};

export const confirmChildSelectionAction = (data) => {
  const payload = {
    serviceMethod: confirmChildSelectionApi.bind(null,data),
    actionTypeSuccess: ActionConstants.CONFIRM_CHILD_SELECTION_SUCCESS,
    actionTypeFailure: ActionConstants.CONFIRM_CHILD_SELECTION_FAILURE,
    actionTypeRequest: ActionConstants.CONFIRM_CHILD_SELECTION_REQUEST,
  };
  return { type: ActionConstants.CONFIRM_CHILD_SELECTION, payload: withHiddenLoader(payload) };
};

export const clearConfirmChildSelectionAction = () => {
  return { type: ActionConstants.CONFIRM_CHILD_SELECTION_CLEAR };
};

export const fetchUploadDocumentsAction = (publicPayload = null) =>{
  const payload = {
    serviceMethod: fetchUploadDocumentsApi.bind(null, publicPayload),
    actionTypeSuccess: ActionConstants.FETCH_UPLOAD_DOCUMENTS_SUCCESS,
    actionTypeFailure: ActionConstants.FETCH_UPLOAD_DOCUMENTS_FAILURE,
    actionTypeRequest: ActionConstants.FETCH_UPLOAD_DOCUMENTS_REQUEST,
    hideLoader: false,
  };
  return { type: ActionConstants.FETCH_UPLOAD_DOCUMENTS, payload: withHiddenLoader(payload) };
};

export const clearFetchUploadDocumentsAction = () => {
  return { type: ActionConstants.FETCH_UPLOAD_DOCUMENTS_CLEAR };
};

export const uploadDocumentAction = (data, publicPayload= null) => {
  const payload = {
    serviceMethod: uploadDocumentApi.bind(null, data, publicPayload),
    actionTypeSuccess: ActionConstants.UPLOAD_DOCUMENT_SUCCESS,
    actionTypeFailure: ActionConstants.UPLOAD_DOCUMENT_FAILURE,
    actionTypeRequest: ActionConstants.UPLOAD_DOCUMENT_REQUEST,
  };
  return { type: ActionConstants.UPLOAD_DOCUMENT, payload: withHiddenLoader(payload) };
};

export const clearUploadDocumentAction = () => {
  return { type: ActionConstants.UPLOAD_DOCUMENT_CLEAR };
};

export const rejectionClarificationAction = (data) => {
  const payload = {
    serviceMethod: rejectionApi.bind(null, data),
    actionTypeSuccess: ActionConstants.REJECTION_CLARIFICATION_SUCCESS,
    actionTypeFailure: ActionConstants.REJECTION_CLARIFICATION_FAILURE,
    actionTypeRequest: ActionConstants.REJECTION_CLARIFICATION_REQUEST,
  };
  return { type: ActionConstants.REJECTION_CLARIFICATION, payload: withHiddenLoader(payload) };
};

export const clearRejectionClarificationAction = () => {
  return { type: ActionConstants.REJECTION_CLARIFICATION_CLEAR };
};

export const generateESignUrlAction = (data, publicPayload = null) => {
  const payload = {
    serviceMethod: generateESignUrlApi.bind(null, data, publicPayload),
    actionTypeSuccess: ActionConstants.GENERATE_ESIGN_URL_SUCCESS,
    actionTypeFailure: ActionConstants.GENERATE_ESIGN_URL_FAILURE,
    actionTypeRequest: ActionConstants.GENERATE_ESIGN_URL_REQUEST,
  };
  return { type: ActionConstants.GENERATE_ESIGN_URL, payload: withHiddenLoader(payload) };
};
  
export const clearGenerateESignUrlAction = () => {
  return { type: ActionConstants.GENERATE_ESIGN_URL_CLEAR };
};

export const getEsignStatusAction = () => {
  const payload = {
    serviceMethod: getEsignStatusApi.bind(null),
    actionTypeSuccess: ActionConstants.GET_ESIGN_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ESIGN_STATUS_FAILURE,
    actionTypeRequest: ActionConstants.GET_ESIGN_STATUS_REQUEST,
  };
  return { type: ActionConstants.GET_ESIGN_STATUS, payload: withHiddenLoader(payload) };
};

export const clearGetEsignStatusAction = () => {
  return { type: ActionConstants.GET_ESIGN_STATUS_CLEAR };
};

export const sendEmailCompanyDirectorAction = (data) => {
  const payload = {
    serviceMethod: sendEmailCompanyDirectorApi.bind(null, data),
    actionTypeSuccess: ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR_SUCCESS,
    actionTypeFailure: ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR_FAILURE,
    actionTypeRequest: ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR_REQUEST,
  };
  return { type: ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR, payload: withHiddenLoader(payload) };
};

export const clearSendEmailCompanyDirectorAction = () => {
  return { type: ActionConstants.SEND_EMAIL_COMPANY_DIRECTOR_CLEAR };
};

export const addAndUpdateBeneficiaryAction = (data) => {
  const payload = {
    serviceMethod: addAndUpdateBeneficiaryApi.bind(null, data),
    actionTypeSuccess: ActionConstants.ADD_AND_UPDATE_BENEFICIARY_SUCCESS,
    actionTypeFailure: ActionConstants.ADD_AND_UPDATE_BENEFICIARY_FAILURE,
    actionTypeRequest: ActionConstants.ADD_AND_UPDATE_BENEFICIARY_REQUEST,
  };
  return { type: ActionConstants.ADD_AND_UPDATE_BENEFICIARY, payload: withHiddenLoader(payload) };
};

export const clearAddAndUpdateBeneficiaryAction = () => {
  return { type: ActionConstants.ADD_AND_UPDATE_BENEFICIARY_CLEAR };
};

export const resendEmailBeneficiaryAction = (data) => {
  const payload = {
    serviceMethod: resendEmailBeneficiaryApi.bind(null, data),
    actionTypeSuccess: ActionConstants.RESEND_EMAIL_BENEFICIARY_SUCCESS,
    actionTypeFailure: ActionConstants.RESEND_EMAIL_BENEFICIARY_FAILURE,
    actionTypeRequest: ActionConstants.RESEND_EMAIL_BENEFICIARY_REQUEST,
  };
  return { type: ActionConstants.RESEND_EMAIL_BENEFICIARY, payload: withHiddenLoader(payload) };
};

export const clearResendEmailBeneficiaryAction = () => {
  return { type: ActionConstants.RESEND_EMAIL_BENEFICIARY_CLEAR };
};

export const getBeneficiaryOwnersAction = () => {
  const payload = {
    serviceMethod: getBeneficiaryOwnersApi.bind(null),
    actionTypeSuccess: ActionConstants.GET_BENEFICIARY_OWNERS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_BENEFICIARY_OWNERS_FAILURE,
    actionTypeRequest: ActionConstants.GET_BENEFICIARY_OWNERS_REQUEST,
  };
  return { type: ActionConstants.GET_BENEFICIARY_OWNERS, payload: withHiddenLoader(payload) };
};

export const clearGetBeneficiaryOwnersAction = () => {
  return { type: ActionConstants.GET_BENEFICIARY_OWNERS_CLEAR };
};

export const sendEmailKycAgreementAction = (data) => {
  const payload = {
    serviceMethod: sendEmailKycAgreementApi.bind(null, data),
    actionTypeSuccess: ActionConstants.SEND_EMAIL_KYC_AGREEMENT_SUCCESS,
    actionTypeFailure: ActionConstants.SEND_EMAIL_KYC_AGREEMENT_FAILURE,
    actionTypeRequest: ActionConstants.SEND_EMAIL_KYC_AGREEMENT_REQUEST,
  };
  return { type: ActionConstants.SEND_EMAIL_KYC_AGREEMENT, payload: withHiddenLoader(payload) };
};

export const clearSendEmailKycAgreementAction = () => {
  return { type: ActionConstants.SEND_EMAIL_KYC_AGREEMENT_CLEAR };
};


export const panValidationKycAgreementAction = (data, publicPayload = null) => {
  const payload = {
    serviceMethod: panValidationKycAgreement.bind(null, data, publicPayload),
    actionTypeSuccess: ActionConstants.PAN_KYC_AGREEMENT_SUCCESS,
    actionTypeFailure: ActionConstants.PAN_KYC_AGREEMENT_FAILURE,
    actionTypeRequest: ActionConstants.PAN_KYC_AGREEMENT_REQUEST,
  };
  return { type: ActionConstants.PAN_KYC_AGREEMENT, payload: withHiddenLoader(payload) };
};

export const clearPanValidationKycAgreementAction = () => {
    return { type: ActionConstants.PAN_KYC_AGREEMENT_CLEAR };
};

export const getAgreementEsignUrlAction = (publicPayload = null, additionalData = {}) => {
  const payload = {
    serviceMethod: getAgreementEsignUrlApi.bind(null, publicPayload, additionalData),
    actionTypeSuccess: ActionConstants.GET_AGREEMENT_ESIGN_URL_SUCCESS,
    actionTypeFailure: ActionConstants.GET_AGREEMENT_ESIGN_URL_FAILURE,
    actionTypeRequest: ActionConstants.GET_AGREEMENT_ESIGN_URL_REQUEST,
  };
  return { type: ActionConstants.GET_AGREEMENT_ESIGN_URL, payload: withHiddenLoader(payload) };
};

export const clearGetAgreementEsignUrlAction = () => {
    return { type: ActionConstants.GET_AGREEMENT_ESIGN_URL_CLEAR };
};

export const getDocumentEsignStatusAction = (publicPayload = {}, options: LoaderOptions = {}) =>{
  const payload = {
    serviceMethod: getDocumentEsignStatusApi.bind(null, publicPayload),
    actionTypeSuccess: ActionConstants.GET_DOCUMENT_ESIGN_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_DOCUMENT_ESIGN_STATUS_FAILURE,
    actionTypeRequest: ActionConstants.GET_DOCUMENT_ESIGN_STATUS_REQUEST,
    hideLoader: true,
    ...options,
  };
  return { type: ActionConstants.GET_DOCUMENT_ESIGN_STATUS, payload: withHiddenLoader(payload) };
};

export const clearGetDocumentEsignStatusAction = () => {
    return { type: ActionConstants.GET_DOCUMENT_ESIGN_STATUS_CLEAR };
};

export const getAgreementEsignStatusAction = (publicPayload = null, options: LoaderOptions = {})=>{
  const payload = {
    serviceMethod: getAgreementEsignStatusApi.bind(null, publicPayload),
    actionTypeSuccess: ActionConstants.GET_AGREEMENT_ESIGN_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_AGREEMENT_ESIGN_STATUS_FAILURE,
    actionTypeRequest: ActionConstants.GET_AGREEMENT_ESIGN_STATUS_REQUEST,
    hideLoader: true,
    ...options,
  };
  return { type: ActionConstants.GET_AGREEMENT_ESIGN_STATUS, payload: withHiddenLoader(payload) };
};

export const clearGetAgreementEsignStatusAction = () => {
    return { type: ActionConstants.GET_AGREEMENT_ESIGN_STATUS_CLEAR };
};

export const downloadReportsAction = (data) => {
  const payload = {
    serviceMethod: getDownloadReportsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.DOWNLOAD_REPORTS_SUCCESS,
    actionTypeFailure: ActionConstants.DOWNLOAD_REPORTS_FAILURE,
    actionTypeRequest: ActionConstants.DOWNLOAD_REPORTS_REQUEST,
  };
  return { type: ActionConstants.DOWNLOAD_REPORTS, payload: withHiddenLoader(payload) };
};

export const clearDownloadReportsAction = () => {
  return { type: ActionConstants.DOWNLOAD_REPORTS_CLEAR };
};  


// ckyc 

export const sendCkycVerificationCodeAction = (data) => {
  const payload = {
    serviceMethod: sendVerificationCodeCkyc.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC_SUCCESS,
    actionTypeFailure: ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC_FAILURE,
    actionTypeRequest: ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC_REQUEST,
  };

  return { type: ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC, payload: withHiddenLoader(payload) };
};

export const clearCkycVerificationCodeAction = () => {
  return { type: ActionConstants.POST_SEND_VERIFICATION_CODE_CKYC_CLEAR };
};

export const verifyCkycOtpAction = (data) => {
  const payload = {
    serviceMethod: verifyCkycOtp.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_VERIFY_CKYC_CODE_SUCCESS,
    actionTypeFailure: ActionConstants.POST_VERIFY_CKYC_CODE_FAILURE,
    actionTypeRequest: ActionConstants.POST_VERIFY_CKYC_CODE_REQUEST,
  };

  return { type: ActionConstants.POST_VERIFY_CKYC_CODE, payload: withHiddenLoader(payload) };
};

export const clearVerifyCkycOtpAction = () => {
  return { type: ActionConstants.POST_VERIFY_CKYC_CODE_CLEAR };
};

export const downloadCkycDataAction = (data) => {
  const payload = {
    serviceMethod: downloadCkycData.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_DOWNLOAD_CKYC_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.POST_DOWNLOAD_CKYC_DATA_FAILURE,
    actionTypeRequest: ActionConstants.POST_DOWNLOAD_CKYC_DATA_REQUEST,
  };

  return { type: ActionConstants.POST_DOWNLOAD_CKYC_DATA, payload: withHiddenLoader(payload) };
};

export const clearDownloadCkycDataAction = () => {
  return { type: ActionConstants.POST_DOWNLOAD_CKYC_DATA_CLEAR };
};

export const mapCkycDataAction = (data, publicPayload = null) => {
  const payload = {
    serviceMethod: mapCkycData.bind(null, data, publicPayload),
    actionTypeSuccess: ActionConstants.POST_MAP_CKYC_DATA_SUCCESS,
    actionTypeFailure: ActionConstants.POST_MAP_CKYC_DATA_FAILURE,
    actionTypeRequest: ActionConstants.POST_MAP_CKYC_DATA_REQUEST,
  };

  return { type: ActionConstants.POST_MAP_CKYC_DATA, payload: withHiddenLoader(payload) };
};

export const clearMapCkycDataAction = () => {
  return { type: ActionConstants.POST_MAP_CKYC_DATA_CLEAR };
};

export const updatePciDssConsentAction = () => {
  const payload = {
    serviceMethod: updatePciDssConsentApi.bind(null),
    actionTypeSuccess: ActionConstants.UPDATE_PCI_DSS_CONSENT_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_PCI_DSS_CONSENT_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_PCI_DSS_CONSENT_REQUEST,
  };
  return { type: ActionConstants.UPDATE_PCI_DSS_CONSENT, payload: withHiddenLoader(payload) };
};

export const clearUpdatePciDssConsentAction = () => {
  return { type: ActionConstants.UPDATE_PCI_DSS_CONSENT_CLEAR };
};
